import { getParkByCode } from '@havenengineering/module-shared-library/dist/utils/parks/getters';
import { HolidayType } from '@havenengineering/module-shared-library/dist/utils/parks/types';
import { getFilterWhenSelection } from '../../../helpers/dates';
import { Query } from '../../../types/v2/holiday-search';
import { pluralise } from '../../../helpers';

export const getHolidaysHeaderTitle = (query: Query) => {
  const adults = query?.adults ? +query?.adults : 0;
  const children = query?.children ? +query?.children : 0;
  const tots = query?.tots ? +query?.tots : 0;
  const dogs = query?.dogs ? +query?.dogs : 0;

  const numberOfBeds = query?.selectedBeds ? `${query?.selectedBeds} beds, ` : '';
  const guests = query?.adults ? `${adults + children + tots}` : '';
  const guestSum =
    dogs > 0
      ? `${guests}  guests + ${dogs} ${pluralise(dogs, 'dog', 'dogs')}, `
      : `${guests} guests, `;

  const formattedArrivalDate =
    query?.arrivalDate && query?.duration && getFilterWhenSelection(query, true);
  const arrivalDate = formattedArrivalDate ? `${formattedArrivalDate}, ` : '';
  const parkName = query?.parkCode
    ? `${getParkByCode(HolidayType.HOLIDAY, query?.parkCode || '')?.name}, `
    : '';
  const packageType = query?.packageType
    ? `${query.packageType.charAt(0).toUpperCase() + query.packageType.toLowerCase().slice(1)}, `
    : '';
  const selectedGrade = query?.selectedGradeName ? `${query?.selectedGradeName}, ` : '';
  const headerTitle = `${arrivalDate}${parkName}${packageType}${selectedGrade}${numberOfBeds}${
    adults ? guestSum : ''
  }`.replace(/,\s*$/, '');
  return `${headerTitle} | Haven`;
};
